import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=0cfc7f72&scoped=true"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"
import style0 from "./Mailings.vue?vue&type=style&index=0&id=0cfc7f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc7f72",
  null
  
)

export default component.exports